
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class PreviewDialog extends Vue {
    @Prop({ type: Boolean, required: false, default: false })
    public value!: boolean;

    public onClose(): void {
        this.$emit('input', false);
    }
}
